module.exports = __webpack_public_path__ + "media/images/MarmosetIcon-01-68d909b6.png";